import {SvgIcon} from "@material-ui/core";

export const CustomPersonIcon = (props) => {
    return (
        <SvgIcon viewBox="0 0 25 25" fill="#76808A" {...props}>
            <path d="M12.0439 12.5327C14.2539 12.5327 16.0439 10.7427 16.0439 8.53271C16.0439 6.32271 14.2539 4.53271 12.0439 4.53271C9.83395 4.53271 8.04395 6.32271 8.04395 8.53271C8.04395 10.7427 9.83395 12.5327 12.0439 12.5327ZM12.0439 14.5327C9.37395 14.5327 4.04395 15.8727 4.04395 18.5327V19.5327C4.04395 20.0827 4.49395 20.5327 5.04395 20.5327H19.0439C19.5939 20.5327 20.0439 20.0827 20.0439 19.5327V18.5327C20.0439 15.8727 14.7139 14.5327 12.0439 14.5327Z"/>
        </SvgIcon>
    )
}
